import(/* webpackMode: "eager" */ "/builds/kor-app/blockchain/kor_ui/apps/fan/src/app/(app)/page.tsx");
